import { parseApiResponse } from '@/shared/utils/apiResponse';
import { apiDelete, apiGet, apiPost } from '@/shared/utils/requestBuilder';
import type { EscritorioConvite, ListarConvitesFilters } from '@/types/escritorio/escritorioTypes';

import type { ConvidarComSetoresDto } from '../../types/convitesTenant';

// Rota admin: o escritório vem do path. A rota do cliente (`/convites-escritorio/escritorio/:id`)
// autoriza pelo papel no workspace do header — e a equipe interna não é membro dos escritórios que
// administra, então o painel não conseguia nem listar nem cancelar convite do tenant aberto.
const rota = (escritorioId: string) => `/admin/escritorios/${escritorioId}/convites`;

export const convitesTenantService = {
  listar: async (
    escritorioId: string,
    filters?: ListarConvitesFilters,
  ): Promise<EscritorioConvite[]> => {
    const params = new URLSearchParams();
    if (filters?.usado !== undefined) params.append('usado', String(filters.usado));
    if (filters?.cancelado !== undefined) params.append('cancelado', String(filters.cancelado));

    const query = params.toString() ? `?${params.toString()}` : '';
    const response = await apiGet(`${rota(escritorioId)}${query}`);

    return parseApiResponse<EscritorioConvite[]>(response);
  },

  convidar: async (
    escritorioId: string,
    data: ConvidarComSetoresDto,
  ): Promise<{ convites: EscritorioConvite[]; totalEnviados: number }> => {
    const response = await apiPost(rota(escritorioId), data);

    return parseApiResponse<{ convites: EscritorioConvite[]; totalEnviados: number }>(response);
  },

  cancelar: async (escritorioId: string, conviteId: string): Promise<void> => {
    const response = await apiDelete(`${rota(escritorioId)}/${conviteId}`);

    await parseApiResponse<null>(response, { allowNoContent: true });
  },
};
